import { render, staticRenderFns } from "./BColorPicker.vue?vue&type=template&id=0a832c98&scoped=true&"
import script from "./BColorPicker.vue?vue&type=script&lang=js&"
export * from "./BColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BColorPicker.vue?vue&type=style&index=0&id=0a832c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a832c98",
  null
  
)

export default component.exports